import { useTranslation } from 'react-i18next'

import { ICON_COLOR, ICON_HEIGHT_48, IconNG } from '../../Icon'
import Text from '../../Text'
import { GRETA_AI_CHAT_EMPTY_STATE_SUBTITLE_KEY } from '../GretaAIChat.constants'

import { getGretaGreetingHeading } from './GretaAIChatEmptyStateGreeting.utils'

import * as styles from './GretaAIChatEmptyStateGreeting.module.css'

import GretaAvatar from '../../../icons/unique/ai/avatar.svg'

function GretaAIChatEmptyStateGreeting({
  displayName,
  subtitleKey = GRETA_AI_CHAT_EMPTY_STATE_SUBTITLE_KEY,
}) {
  const { t } = useTranslation()

  return (
    <>
      <IconNG
        Icon={GretaAvatar}
        className={styles.avatar}
        color={ICON_COLOR.Without}
        size={ICON_HEIGHT_48}
      />

      <Text Element='div' className={styles.heading}>
        {getGretaGreetingHeading(t, displayName)}
      </Text>
      <Text isSecondary Element='div' className={styles.subtitle}>
        {t(subtitleKey)}
      </Text>
    </>
  )
}

export default GretaAIChatEmptyStateGreeting
